import React from 'react';

import {Beer} from 'typescript/models/Beer';

import BeersList from '../BeersList/BeersList';

interface IProps {
  allBeers: Beer[];
  getNextPageItems: (page: number) => void;
  beersDropdownPage: number;
  beerTotalPages: number;
  search: string;
  className: string;
}

export const BeerDropdown = ({
  className,
  allBeers,
  getNextPageItems,
  beersDropdownPage,
  beerTotalPages,
  search,
}: IProps) => {
  return (
    <>
      {allBeers.length > 0 ? (
        <div className={className}>
          <BeersList
            hasMore={beersDropdownPage < beerTotalPages}
            page={beersDropdownPage}
            getNextPage={getNextPageItems}
            list={allBeers}
          />
        </div>
      ) : (
        <div className={`${className}__zero-state`}>
          <span className="zero-state-text">
            There isn’t a match for <span className="zero-state-search">{search}</span>
          </span>
        </div>
      )}
    </>
  );
};
